import React, { Component } from "react";
import ProductHeader from "../../ProductDetails/ProductHeader";
import { ReactComponent as Logo } from "../assets/browser.svg";
import MyStepper from "../MyStepper";
import UserForm from "./UserForm";
import { connect } from "react-redux";
import ActionButton from "../../ActionButton";
import { isValidPhoneNumber } from "react-phone-number-input";
//Actions
import { saveCustomerContact } from "../../../store/actions";
import SignUp from "../../common/SignUp";
import VerifyPhone from "./VerifyPhone";

import { createCustomerWithAddressAndPhone } from "../../../store/actions/auth";
const isVirginPhoneNumber = (phone) => {
  // For Virgin Mobile Kuwait. Numbers are 8 digits long and start with 41
  if (!phone) return false;
  if (
    phone.startsWith("+965") &&
    phone.split("+965")[1].startsWith("41") &&
    phone.split("+965")[1].length === 8
  )
    return true;
  return false;
};
const validateEmail = (email) => {
  const re =
    /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return re.test(String(email).toLowerCase());
};
class index extends Component {
  state = {
    name: this.props.auth.user?.name || "",
    civilID: "",
    email: this.props.auth.user?.email || "",
    phone: this.props.auth.user?.phone || "",
    birthday: !!this.props.auth.user?.birth_date
      ? new Date(
          this.props.auth.user?.birth_date.substring(0, 4),
          this.props.auth.user?.birth_date.substring(5, 7),
          this.props.auth.user?.birth_date.substring(8, 10)
        )
      : new Date(),
    nameError: false,
    emailError: false,
    nameLengthError: false,
    civilIDError: false,
    phoneError: false,
    countryDialCode: "",
    optInMarketing: this.props.auth.user?.opt_in_marketing,
    contactChannel: this.props.auth.user?.contact_channel,

    showForm:
      this.props.auth.user || !this.props.settings.enable_social_auth
        ? true
        : false,

    phoneFieldKey: Math.random() * 99999,

    verifyPhoneModalOpen: false,
  };

  componentDidMount = () => {
    window.scrollTo(0, 0);
    const cc = this.props.customerContact;

    if (cc) {
      this.setState((prevState) => ({
        name: cc.name || "",
        civilID: cc.civilID || "",
        email: cc.email || "",
        phone: cc.phone || "",
        birthday: cc.birth_date || "",
        optInMarketing: cc.hasOwnProperty("opt_in_marketing")
          ? cc.opt_in_marketing
          : prevState.optInMarketing,
        contactChannel: cc.hasOwnProperty("contact_channel")
          ? cc.contact_channel
          : prevState.contactChannel,
      }));
    }
  };

  handleChange = (e, eventPhone) => {
    const { settings } = this.props;

    if (eventPhone) {
      this.setState({ countryDialCode: eventPhone.dialCode });
    }
    if (typeof e == "string") {
      if (e.startsWith("+" + eventPhone.dialCode)) {
        this.setState({ phone: e });
      } else {
        this.setState({ phoneFieldKey: Math.random() * 999999 });
      }
      if (e.length >= this.state.phone.length)
        this.setState({ phoneError: false });
    } else {
      this.setState({ [e.target.name]: e.target.value });
      if (this.state.name?.trim()?.length < 25 && this.state.nameLengthError)
        this.setState({ nameLengthError: false });
      if (this.state.name && this.state.nameError)
        this.setState({ nameError: false });
      if (
        settings.email_required &&
        this.state.email &&
        validateEmail(this.state.email) &&
        this.state.emailError
      ) {
        this.setState({ emailError: false });
      } else if (this.state.civilID && this.state.civilIDError)
        this.setState({ civilIDError: false });
    }
  };

  handleNext = (location) => {
    const { settings } = this.props;
    let error = false;
    if (!this.state.name.trim()) {
      error = true;
      this.setState({ nameError: true });
    } else if (this.state.name.trim().length > 25) {
      error = true;
      this.setState({ nameLengthError: true });
    }
    if (settings.email_required && !validateEmail(this.state.email?.trim())) {
      error = true;
      this.setState({ emailError: true });
    }
    if (
      this.props.settings.ask_for_civil_id &&
      (!this.state.civilID || !this.state.civilID.trim())
    ) {
      error = true;
      this.setState({ civilIDError: true });
    }

    if (
      (!isValidPhoneNumber(this.state.phone) &&
        !isVirginPhoneNumber(this.state.phone)) ||
      this.state.countryDialCode == this.state.phone.substring(1)
    ) {
      error = true;
      this.setState({ phoneError: true });
    }

    if (!error) {
      if (
        this.props.settings.enable_aseer_time &&
        this.props.auth?.user &&
        this.props.customerContact?.phone != this.state.phone
      ) {
        this.setState({ verifyPhoneModalOpen: true });
      } else {
        this.props.saveCustomerContact(this.state);
        if (this.props.settings.enable_dot) {
          this.props.createCustomerWithAddressAndPhone();
        }
        this.props.history.push(location);
      }
    }
  };
  handleBirthdayChange = (date) => {
    this.setState({ birthday: date });
  };
  handleChangeOptInMarketing = (check) => {
    this.setState({ optInMarketing: check });
  };

  handleChangeContactChannel = (channel) => {
    this.setState({ contactChannel: channel });
  };

  render() {
    const { language, settings } = this.props;
    const { showForm } = this.state;
    let previousPath;
    if (this.props.history.location.state) {
      previousPath = this.props.history.location.state.prevPath;
    }

    return (
      <div
        className="  w-100 mx-0 "
        style={{
          backgroundColor: "white",
          minHeight: 690,
        }}
      >
        {previousPath !== "/checkout/confirmation" ? (
          <ProductHeader />
        ) : (
          <ProductHeader
            onBack={() => this.props.history.push("/checkout/confirmation")}
          />
        )}

        {this.state.verifyPhoneModalOpen && (
          <VerifyPhone
            open={this.state.verifyPhoneModalOpen}
            onClose={async (verified) => {
              if (verified) {
                this.props.saveCustomerContact(this.state);
                await this.props.createCustomerWithAddressAndPhone(true);

                window.location.replace(
                  previousPath === "profile"
                    ? "/profile"
                    : "/checkout/confirmation"
                );
              }
              this.setState({ verifyPhoneModalOpen: false });
            }}
            phone={this.state.phone}
            history={this.props.history}
            disableEditing={true}
          />
        )}
        <div
          className="border-top w-100"
          style={{
            marginTop: 55,

            backgroundColor: "white",
          }}
        >
          {previousPath !== "/checkout/confirmation" &&
            previousPath !== "profile" && (
              <MyStepper
                selected={language == "english" ? 0 : 1}
                numberOfSteps={
                  (this.props.settings.enable_delivery ||
                    this.props.settings.enable_pickup) &&
                  (this.props.cart.charged_items > 0 ||
                    this.props.cart.delivered_items > 0)
                    ? 2
                    : 1
                }
              />
            )}

          <Logo width="100" height="100" style={{ marginTop: 98 }} />

          <p className="text-muted mt-3 mb-3 bold" style={{ fontSize: 22 }}>
            {language == "english" ? "Contact Information" : "بيانات التواصل"}
          </p>
          {/* <p className="mx-auto w-75" style={{ fontSize: 15, color: "#999" }}>
            {language == "english"
              ? "We need this information to contact you and get the order delivered"
              : "نحتاج هذي المعلومات لنتواصل معك واتمام عملية التوصيل"}
          </p> */}
          <div style={{ marginTop: 35 }}>
            <SignUp
              onContinueAsGuest={() => {
                this.setState({ showForm: true });
                window.setTimeout(
                  () => window.scrollTo({ top: 10000, behavior: "smooth" }),
                  50
                );
              }}
            />
          </div>
          {showForm && (
            <>
              <UserForm
                firstStepRef={this.firstStepRef}
                name={this.state.name}
                civilID={this.state.civilID}
                phone={this.state.phone}
                email={this.state.email}
                emailError={this.state.emailError}
                handleChange={this.handleChange}
                nameError={this.state.nameError}
                nameLengthError={this.state.nameLengthError}
                civilIDError={this.state.civilIDError}
                phoneError={this.state.phoneError}
                dateValue={this.state.birthday}
                onChangeDate={this.handleBirthdayChange}
                highlightColor="#0099cc"
                phoneFieldKey={this.state.phoneFieldKey}
                optInMarketing={this.state.optInMarketing}
                contactChannel={this.state.contactChannel}
                handleChangeOptInMarketing={this.handleChangeOptInMarketing}
                handleChangeContactChannel={this.handleChangeContactChannel}
              />
              <div style={{ height: 250, background: "white" }}></div>
              {previousPath === "profile" ||
              previousPath === "/checkout/confirmation" ? (
                <ActionButton
                  action={language == "english" ? "Save" : "حفظ"}
                  onClick={() =>
                    this.handleNext(
                      previousPath === "profile"
                        ? "/profile"
                        : "/checkout/confirmation"
                    )
                  }
                  color="#0099cc"
                />
              ) : (
                <ActionButton
                  action={language == "english" ? "Next" : "التالي"}
                  onClick={() => this.handleNext("/checkout/confirmation")}
                  color="#0099cc"
                />
              )}
            </>
          )}
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    language: state.store.language,
    customerContact: state.customers.customerContact,
    settings: state.store.store.settings,
    cart: state.cart,
    auth: state.auth,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    saveCustomerContact: (customer) => dispatch(saveCustomerContact(customer)),
    createCustomerWithAddressAndPhone: (withoutAddress) =>
      dispatch(createCustomerWithAddressAndPhone(withoutAddress)),
  };
};

export { validateEmail };
export default connect(mapStateToProps, mapDispatchToProps)(index);
